import type { ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { Icon } from './Icon';
import { cx } from '@/lib/cx';

interface ChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  selected: boolean;
  onSelectedChange: (selected: boolean) => void;
}

/** A toggle chip (filters, one-click reasons). Exposes its state with aria-pressed. */
export const Chip = forwardRef<HTMLButtonElement, ChipProps>(function Chip(
  { selected, onSelectedChange, className, children, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-pressed={selected}
      onClick={() => onSelectedChange(!selected)}
      className={cx(
        'inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm transition-colors',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
        'disabled:cursor-not-allowed disabled:opacity-50',
        selected
          ? 'border-accent bg-accent-soft text-accent-strong'
          : 'border-line bg-surface text-ink-soft hover:border-ink-soft/50 hover:text-ink',
        className,
      )}
      {...rest}
    >
      {selected && <Icon name="check" className="h-3.5 w-3.5" />}
      {children}
    </button>
  );
});
